angular.module('bmsApp.sm.quote')
	.controller('SMQuoteIndexCtrl', [
		'$log',
		'$state',
		'$scope',
		'SMJobSvc',
		'LicenseOptionsSvc',
		'$cookies',
		'$localStorage',
		'ngTableParams',
		'$q',
		function ($log,
				  $state,
				  $scope,
				  SMJobSvc,
				  LicenseOptionsSvc,
				  $cookies,
				  $localStorage,
				  ngTableParams,
				  $q) {

			var defaultTableParams = function () {
				return {
					page: 1, // show first page
					count: $scope.config.table.params.count, // count per page
					sorting: {
						id: 'desc' // initial sorting
					},
					filter: {
						search: '',
						converted: false,
						status: [1],
						closed: false,
						licences: null,
						licenceType: null,
					}
				};
			};

			var initialIndexParams = function () {
				if (angular.isDefined($localStorage.smQuoteIndexParams)) {
					self.searchText = $localStorage.smQuoteIndexParams.filter.search;
					return angular.extend({}, defaultTableParams(), $localStorage.smQuoteIndexParams);
				}
				else {
					return angular.extend({}, defaultTableParams());
				}
			};

			function init() {

				self.statusOptions = [
					{
						value: 1,
						label: 'Open'
					},
					{
						value: 3,
						label: 'Lost'
					}
				];


				var promises = {
					licenseOptions: LicenseOptionsSvc.license(),
					licenceTypeOptions: LicenseOptionsSvc.network(),
				};
				$q.all(promises)
					.then(function (response) {
						$scope.licenseOptions = response.licenseOptions.data.options;
						$scope.licenseTypeOptions = response.licenceTypeOptions.data.options;
						$scope.loading = false;
					});

				var params = initialIndexParams();
				self.quoteFilters = angular.copy(params.filter);

				self.tableParams = new ngTableParams(params, {
					total: 0, // length of data
					counts: $scope.config.table.settings.counts, // available page counts
					getData: function ($defer, params) {
						// $localStorage.smQuoteIndexParams = params.$params;
						SMJobSvc.index(params.$params)
							.then(function (response) {
								params.total(response.data.sm_job_filtered_count);
								$defer.resolve(response.data.sm_job_collection);
								$scope.$emit('quoteIndexUpdated', {
									quote_collection: response.data.sm_job_collection,
									quote_filtered_count: response.data.sm_job_filtered_count,
									quote_total_count: response.data.sm_job_total_count,
									quote_total_value: response.data.total_quote_value,
									quotes_over_28_days: response.data.total_over_28_days
								});
								// Check if we've exceeded our page size, if we have, go back
								if (response.data.sm_job_total_count > 0 && !response.data.sm_job_collection.length) {
									let newParams = angular.copy(self.tableParams.$params);
									newParams.page--;
									angular.extend(self.tableParams.$params, newParams);
								}
								self.loading = false;
							});
					}
				});
			}

			// text search
			function filterChanged() {
				self.tableParams.$params.filter.search = self.searchText;
			}

			// Store the table params whenever anything changes
			$scope.$watch(function() {
				return self.tableParams.$params;
			}, function(value) {
				if (angular.isObject(value)) {
					$localStorage.tgQuoteIndexParams = value;
				}
			}, true);

			// other filters
			function filterApply() {
				angular.extend(self.tableParams.$params.filter, angular.copy(self.quoteFilters));
			}

			function filterReset() {
				angular.extend(self.tableParams.$params, defaultTableParams());
				angular.extend(self.quoteFilters, defaultTableParams().filter);
			}

			function rowClicked(quote) {
				$state.go('main.sm.quote.index.view', {
					quoteId: quote.id
				});
			}

			var self = $scope.SMQuoteIndexCtrl = {
				loading: true,
				methods: {
					init: init,
					filterChanged: filterChanged,
					filterApply: filterApply,
					filterReset: filterReset,
					rowClicked: rowClicked
				}
			};

		}
	]);